import { RoomSearchInfo } from '@/__generated';
import { HOTEL_SEARCHBOX_CONFIG } from '@/config';
import { range } from 'lodash';
import React from 'react';
import Select from 'react-select';

const ChildrenAgeOptions = [6, 7, 8, 9, 10, 11].map(i => ({ label: `${i}`, value: i }));

type Props = {
  roomIndex: number;
  onRemoveRoom: (index: number) => void;
  room: RoomSearchInfo;
  onRoomChange: (roomIndex: number, key: 'noOfAdult' | 'noOfChild' | 'childAges', value: number | number[]) => void;
};

export default function RoomInput({ room, roomIndex, onRemoveRoom, onRoomChange }: Props) {
  const onAdultChange = value => {
    onRoomChange(roomIndex, 'noOfAdult', value);
  };
  const onChildrenChange = value => {
    onRoomChange(roomIndex, 'noOfChild', value);
  };
  const onChildrenAgeChange = (ageIndex: number, value) => {
    let ages = [...(room.childAges || [])];
    ages[ageIndex] = value;
    onRoomChange(roomIndex, 'childAges', ages);
  };

  const [adultsOptions, childrenOptions] = React.useMemo(() => {
    let maxAdultAllowSelect = HOTEL_SEARCHBOX_CONFIG.maxPassengerPerRoom - (room.noOfChild || 0);
    let maxChildAllowSelect = HOTEL_SEARCHBOX_CONFIG.maxPassengerPerRoom - (room.noOfAdult || 0);
    const _adultsOptions = range(1, maxAdultAllowSelect + 1).map(i => ({ label: `${i}`, value: i }));
    const _childrenOptions = range(0, maxChildAllowSelect + 1).map(i => ({ label: `${i}`, value: i }));

    return [_adultsOptions, _childrenOptions];
  }, [room]);
  return (
    <div className="row x-gap-6 y-gap-6 mb-10">
      <div className="col-12 fw-500 text-blue-1  d-flex items-center justify-content-between">
        <span className="text-decoration-underline">Room {roomIndex + 1}</span>
        {roomIndex !== 0 ? (
          <button className="text-red-1  py-10 text-14 " onClick={() => onRemoveRoom(roomIndex)}>
            <i className="icon-trash text-12 mr-5" />
          </button>
        ) : null}
      </div>

      <div className="col-6">
        <div className="text-14 fw-500">{`Adults(${HOTEL_SEARCHBOX_CONFIG.adultMinAge}+)`}</div>
        <div className="select-container">
          <Select
            classNamePrefix="omega-select cursor-pointer"
            className="w-100"
            placeholder=""
            options={adultsOptions}
            value={adultsOptions.find(x => x.value === room.noOfAdult)}
            onChange={v => onAdultChange(v?.value || 2)}
          />
        </div>
      </div>
      <div className="col-6">
        <div className="text-14 fw-500">{`Children(${HOTEL_SEARCHBOX_CONFIG.childrenMinAge}-${HOTEL_SEARCHBOX_CONFIG.childrenMaxAge})`}</div>
        <div className="select-container">
          <Select
            classNamePrefix="omega-select cursor-pointer"
            className="w-100"
            placeholder=""
            options={childrenOptions}
            value={childrenOptions.find(x => x.value === room.noOfChild)}
            onChange={v => onChildrenChange(v?.value || 0)}
          />
        </div>
      </div>
      {room.childAges?.map((age, index) => {
        return (
          <div className="col-6 mt-2" key={index}>
            <div className="text-14 fw-500">Children {index + 1} age</div>
            <div className="select-container">
              <Select
                classNamePrefix="omega-select cursor-pointer"
                className="w-100"
                placeholder=""
                options={ChildrenAgeOptions}
                value={ChildrenAgeOptions.find(x => x.value === age)}
                onChange={v => onChildrenAgeChange(index, v?.value || 8)}
              />
            </div>
          </div>
        );
      })}
    </div>
  );
}
